import React from 'react';
import { Box } from '@mui/material';
import { HeroSection } from '../components/sections/HeroSection';
import { FeaturesSection } from '../components/sections/FeaturesSection';
import { HowItWorksSection } from '../components/sections/HowItWorksSection';
import { CTASection } from '../components/sections/CTASection';

/**
 * Landing page homepage
 * Combines Hero, Features, How It Works, and CTA sections
 */
export const HomePage: React.FC = () => {
  return (
    <Box>
      <HeroSection />
      <FeaturesSection />
      <HowItWorksSection />
      <CTASection />
    </Box>
  );
};
